
import { getRole } from '@/api/role';
import { getInterestsList } from '@/api/interests';
import { getUserInfo } from '@/api/user';
import { updateCompany, getCompanyInfo } from '@/api/company';
import { IInterests, IRole } from '@/types';
import { IUserData, ICompanyDetail } from '@/types/company';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { UserModule } from '@/store/user';
import { getFile, uploadFile, uploadFilePdf } from '@/api/attachedFile';
import { getEncData } from '@/api/nice';
import { IAttachedFile } from '@/types/attachedFile';
import { NiceModule } from '@/store/nice';
import CompanyDetail from '@/views/mypage/components/CompanyDetail.vue';
import PrImageUploads from '@/views/mypage/components/PrImageUploads.vue';
import YoutubeLinks from '@/views/mypage/components/YoutubeLinks.vue';

const ROLE_ID_STARTUP = 'ROLE_33c57d08-f5f8-4d62-9791-a68f3f9c786e';
const ROLE_ID_INVESTOR = 'ROLE_508055ae-27cb-4fc1-8afe-a36f8e961451';
const ROLE_ID_INNOVATION = 'ROLE_b3a47a0a-48b8-45a7-9bf1-9a6bb34f38b6';

@Component({
  name: 'Company',
  components: {
    VueDaumPostcode,
    CompanyDetail,
    PrImageUploads,
    YoutubeLinks,
  },
})
export default class extends Vue {
  private readonly defaultMemberPlaceholder = `성명 :
직책 :
약력 : (ex) - 2025.10 주요내용)
주요구성원이 많을 경우 아래행을 추가하여 입력해주세요`;

  mounted() {
    if (UserModule.token) {
      if (this.$route.params.roleCode) {
        if (this.$route.name === 'AppUserJoin') this.$router.push({ name: 'AppMain' });
        else this.$router.push({ name: 'Index' });
      } else {
        this.$validator.pause();
        getUserInfo().then((res) => {
          const { uid } = res.data;
          UserModule.setUserUid(uid);
          this.formData = {
            ...this.formData,
            ...res.data,
          };

          const userRole = res.data.roles && res.data.roles[0] ? res.data.roles[0] : '';
          let determinedType = 'O'; // 기본값: 대중견(O)

          if (userRole === ROLE_ID_STARTUP) {
            determinedType = 'S'; // 스타트업
          } else if (userRole === ROLE_ID_INVESTOR) {
            determinedType = 'I'; // 투자사
          } else if (userRole === ROLE_ID_INNOVATION) {
            determinedType = 'O'; // 그 외: 대중견
          }

          this.selectedRoleCode = determinedType;

          this.formCData.coDept = determinedType;

          getCompanyInfo(uid).then((cres) => {
            if (!cres.data) {
              this.formCData = this.mapUserToCompany(res.data);
            } else {
              this.formCData = {
                ...this.formCData,
                ...cres.data,
                youtubeList: cres.data.youtubeList || [''],
              };

              this.selectedRoleCode = determinedType;

              if (this.formCData.coDept !== determinedType) {
                this.formCData.coDept = determinedType;
              }

              this.setBizParts(this.formCData.coBizPart);

              this.prImgFiles = [];
              this.prImgFileUids = [];
              this.prImgInputs = [];

              if (this.formCData.files && this.formCData.files.length > 0) {
                // 1. ord 기준으로 오름차순 정렬 (문자열일 수 있으니 Number 변환)
                const sortedFiles = [...this.formCData.files].sort(
                  (a: any, b: any) => Number(a.ord) - Number(b.ord),
                );

                // 2. 정렬된 순서대로 화면 데이터(prImgFiles) 구성
                sortedFiles.forEach((f, idx) => {
                  if (f.attachedFile) {
                    // 파일 객체 추가
                    this.prImgFiles.push(f.attachedFile);
                    // UID 리스트 동기화 (자식 컴포넌트용)
                    this.prImgFileUids.push(f.attachedFile.uid);
                    // Input 인덱스 추가
                    this.prImgInputs.push(idx);
                  }
                });
              } else {
                // 파일이 하나도 없으면 기본 input 1개 생성
                this.prImgInputs = [0];
              }

              if (this.formCData.youtubeLink) {
                this.formCData.youtubeList = this.formCData.youtubeLink.split('\n');
              } else {
                this.formCData.youtubeList = [];
              }

              if (this.formCData.texts) {
                this.formCData.coMember = this.formCData.texts
                  .filter((t) => t.part === 'coMember')
                  .map((t) => t.content);
              } else {
                this.formCData.coMember = [];
              }
            }
            this.isUpdate = true;
            this.formCData.texts = [];
            this.logoFile = cres.data.logoFile;
            this.bizCertiFile = cres.data.bizCertiFile;
            this.irFile = cres.data.irFile;
            res.data.roles.forEach((r: string) => {
              getRole(r).then((response: any) => {
                this.role = response.data;
              });
              getInterestsList(r).then((response) => {
                this.interestsList = this.interestsList.concat(response.data);
              });
            });
            setTimeout(() => {
              this.$validator.resume();
            }, 1000);
          });
        });
      }
    } else {
      getEncData().then((res) => {
        this.encData = res.data;
      });
      getRole(this.$route.params.roleCode)
        .then((res: any) => {
          this.role = res.data;
          this.formData.roleCode = res.data.roleCode;
        })
        .catch(() => {
          if (this.$route.name === 'Mypage' || this.$route.name === 'Company') this.$router.push({ name: 'JoinTerms' });
          else this.$router.push({ name: 'AppJoinTerms' });
        });
      getInterestsList(this.$route.params.roleCode).then((res) => {
        this.interestsList = res.data;
      });
    }
  }

  private selectedRoleCode = 'S';

  private role: IRole | null = null;

  private isUpdate = false;

  private thumbnailFile = null;

  private determinedType = '';

  private agreeStateInvest = 1;

  private agreeStateBiz = 1;

  private formData: IUserData = {
    userId: '',
    actualName: '',
    phone: '',
    roleCode: '',
    companyName: '',
    companyRegisterNum: '',
    companyTel: '',
    homepage: '',
    logoFileUid: '',
    introduce: '',
    relationUserUid: null,
  };

  private mapUserToCompany(user: any): ICompanyDetail {
    return {
      coDept: '',
      coName: user.companyName || '',
      coNum: user.companyRegisterNum || '',
      coNumStatus: '',
      coTel: user.companyTel || '',
      coPostcode: user.postCode || '',
      coAddr: user.address || '',
      coAddrDetail: user.addressDetail || '',
      coWeb: user.homepage || '',
      coOne: user.introduce || '',
      coDetail: '',
      coCeoHistory: '',
      coTech: '',
      coCeo: user.manager || '',
      coBday: '',
      coBaddr: '',
      coBizPart: '',
      coHistory: '',
      coSelTech: '',
      coValue: '',
      coIr: 0,
      coIrPart: 'NONE',
      coIrAmt: '',
      coIrHopeM: '',
      coApprove: 0,
      modifyId: user.userId || '',
      youtubeList: [''],
      youtubeLink: '',
      coMember: [this.defaultMemberPlaceholder],
      texts: [],
      files: [],
      agreeStateInvest: 1,
      agreeStateBiz: 1,
      relationUserUid: null,
      irFileUid: '',
      logoFileUid: '',
      bizCertiFileUid: '',
      selectedRoleCode: '',
      viewCnt: 0,
      irViewCnt: 0,
      ceoEmail: user.email || '',
    };
  }

  private formCData: ICompanyDetail = {
    coDept: '',
    coName: '',
    coNum: '',
    coNumStatus: '',
    coTel: '',
    coPostcode: '',
    coAddr: '',
    coAddrDetail: '',
    coWeb: '',
    coOne: '',
    coDetail: '',
    coCeoHistory: '',
    coTech: '',
    coCeo: '',
    coBday: '',
    coBaddr: '',
    coBizPart: '',
    coHistory: '',
    coSelTech: '',
    coValue: '',
    coIr: 0,
    coIrPart: 'NONE',
    coIrAmt: '',
    coIrHopeM: '',
    coApprove: 0,
    modifyId: '',
    texts: [],
    files: [],
    youtubeList: [''],
    youtubeLink: '',
    coMember: [this.defaultMemberPlaceholder],
    agreeStateInvest: 1,
    agreeStateBiz: 1,
    relationUserUid: null,
    irFileUid: '',
    logoFileUid: '',
    bizCertiFileUid: '',
    selectedRoleCode: '',
    viewCnt: 0,
    irViewCnt: 0,
    ceoEmail: '',
  };

  private logoFile: IAttachedFile | null = null;

  private bizCertiFile: IAttachedFile | null = null;

  private prImgFiles: IAttachedFile[] = [];

  private prImgFileUids: string[] = [];

  private prImgInputs: number[] = [0];

  private interestsList: IInterests[] = [];

  private irFile: IAttachedFile | null = null;

  private encData = '';

  private coBizPart1A: string | null = null;

  private coBizPart1B: string | null = null;

  private coBizPart2A: string | null = null;

  private coBizPart2B: string | null = null;

  private coBizPart3A: string | null = null;

  private coBizPart3B: string | null = null;

  private cbpaes = [
    {
      label: '농업, 임업 및 어업',
      value: 'A',
      children: [
        { label: '농업', value: '01' },
        { label: '임업', value: '02' },
        { label: '어업', value: '03' },
      ],
    },
    {
      label: '광업',
      value: 'B',
      children: [
        { label: '석탄, 원유 및 천연가스 광업', value: '05' },
        { label: '금속 광업', value: '06' },
        { label: '비금속광물 광업; 연료용 제외', value: '07' },
        { label: '광업 지원 서비스업', value: '08' },
      ],
    },
    {
      label: '제조업',
      value: 'C',
      children: [
        { label: '식료품 제조업', value: '10' },
        { label: '음료 제조업', value: '11' },
        { label: '담배 제조업', value: '12' },
        { label: '섬유제품 제조업; 의복 제외', value: '13' },
        { label: '의복, 의복 액세서리 및 모피제품 제조업', value: '14' },
        { label: '가죽, 가방 및 신발 제조업', value: '15' },
        { label: '목재 및 나무제품 제조업; 가구 제외', value: '16' },
        { label: '펄프, 종이 및 종이제품 제조업', value: '17' },
        { label: '인쇄 및 기록매체 복제업', value: '18' },
        { label: '코크스, 연탄 및 석유정제품 제조업', value: '19' },
        { label: '화학 물질 및 화학제품 제조업; 의약품 제외', value: '20' },
        { label: '의료용 물질 및 의약품 제조업', value: '21' },
        { label: '고무 및 플라스틱제품 제조업', value: '22' },
        { label: '비금속 광물제품 제조업', value: '23' },
        { label: '1차 금속 제조업', value: '24' },
        { label: '금속 가공제품 제조업; 기계 및 가구 제외', value: '25' },
        { label: '전자 부품, 컴퓨터, 영상, 음향 및 통신장비 제조업', value: '26' },
        { label: '의료, 정밀, 광학 기기 및 시계 제조업', value: '27' },
        { label: '전기장비 제조업', value: '28' },
        { label: '기타 기계 및 장비 제조업', value: '29' },
        { label: '자동차 및 트레일러 제조업', value: '30' },
        { label: '기타 운송장비 제조업', value: '31' },
        { label: '가구 제조업', value: '32' },
        { label: '기타 제품 제조업', value: '33' },
        { label: '산업용 기계 및 장비 수리업', value: '34' },
      ],
    },
    {
      label: '전기, 가스, 증기 및 공기 조절 공급업',
      value: 'D',
      children: [{ label: '전기, 가스, 증기 및 공기 조절 공급업', value: '35' }],
    },
    {
      label: '수도, 하수 및 폐기물 처리, 원료 재생업',
      value: 'E',
      children: [
        { label: '수도업', value: '36' },
        { label: '하수, 폐수 및 분뇨 처리업', value: '37' },
        { label: '폐기물 수집, 운반, 처리 및 원료 재생업', value: '38' },
        { label: '환경 정화 및 복원업', value: '39' },
      ],
    },
    {
      label: '건설업',
      value: 'F',
      children: [
        { label: '종합 건설업', value: '41' },
        { label: '전문직별 공사업', value: '42' },
      ],
    },
    {
      label: '도매 및 소매업',
      value: 'G',
      children: [
        { label: '자동차 및 부품 판매업', value: '45' },
        { label: '도매 및 상품 중개업', value: '46' },
        { label: '소매업; 자동차 제외', value: '47' },
      ],
    },
    {
      label: '운수 및 창고업',
      value: 'H',
      children: [
        { label: '육상 운송 및 파이프라인 운송업', value: '49' },
        { label: '수상 운송업', value: '50' },
        { label: '항공 운송업', value: '51' },
        { label: '창고 및 운송관련 서비스업', value: '52' },
      ],
    },
    {
      label: '숙박 및 음식점업',
      value: 'I',
      children: [
        { label: '숙박업', value: '55' },
        { label: '음식점 및 주점업', value: '56' },
      ],
    },
    {
      label: '정보통신업',
      value: 'J',
      children: [
        { label: '출판업', value: '58' },
        { label: '영상ㆍ오디오 기록물 제작 및 배급업', value: '59' },
        { label: '방송업', value: '60' },
        { label: '우편 및 통신업', value: '61' },
        { label: '컴퓨터 프로그래밍, 시스템 통합 및 관리업', value: '62' },
        { label: '정보서비스업', value: '63' },
      ],
    },
    {
      label: '금융 및 보험업',
      value: 'K',
      children: [
        { label: '금융업', value: '64' },
        { label: '보험 및 연금업', value: '65' },
        { label: '금융 및 보험관련 서비스업', value: '66' },
      ],
    },
    {
      label: '부동산업',
      value: 'L',
      children: [{ label: '부동산업', value: '68' }],
    },
    {
      label: '전문, 과학 및 기술 서비스업',
      value: 'M',
      children: [
        { label: '연구개발업', value: '70' },
        { label: '전문 서비스업', value: '71' },
        { label: '건축 기술, 엔지니어링 및 기타 과학기술 서비스업', value: '72' },
        { label: '기타 전문, 과학 및 기술 서비스업', value: '73' },
      ],
    },
    {
      label: '사업시설 관리, 사업 지원 및 임대 서비스업',
      value: 'N',
      children: [
        { label: '사업시설 관리 및 조경 서비스업', value: '74' },
        { label: '사업 지원 서비스업', value: '75' },
        { label: '임대업; 부동산 제외', value: '76' },
      ],
    },
    {
      label: '공공 행정, 국방 및 사회보장 행정',
      value: 'O',
      children: [{ label: '공공 행정, 국방 및 사회보장 행정', value: '84' }],
    },
    {
      label: '교육 서비스업',
      value: 'P',
      children: [{ label: '교육 서비스업', value: '85' }],
    },
    {
      label: '보건업 및 사회복지 서비스업',
      value: 'Q',
      children: [
        { label: '보건업', value: '86' },
        { label: '사회복지 서비스업', value: '87' },
      ],
    },
    {
      label: '예술, 스포츠 및 여가관련 서비스업',
      value: 'R',
      children: [
        { label: '창작, 예술 및 여가관련 서비스업', value: '90' },
        { label: '스포츠 및 오락관련 서비스업', value: '91' },
      ],
    },
    {
      label: '협회 및 단체, 수리 및 기타 개인 서비스업',
      value: 'S',
      children: [
        { label: '협회 및 단체', value: '94' },
        { label: '개인 및 소비용품 수리업', value: '95' },
        { label: '기타 개인 서비스업', value: '96' },
      ],
    },
    {
      label: '가구 내 고용활동 및 달리 분류되지 않은 자가 소비 생산활동',
      value: 'T',
      children: [
        { label: '가구 내 고용활동', value: '97' },
        {
          label: '달리 분류되지 않은 자가 소비를 위한 가구의 재화 및 서비스 생산활동',
          value: '98',
        },
      ],
    },
    {
      label: '국제 및 외국기관',
      value: 'U',
      children: [{ label: '국제 및 외국기관', value: '99' }],
    },
  ];

  private cipList = [
    { value: 'Seed', label: 'Seed' },
    { value: 'Pre-A', label: 'Pre-A' },
    { value: 'Series A', label: 'Series A' },
    { value: 'Series B', label: 'Series B' },
  ];

  private ciList = [
    { value: 1, label: '투자 경험 있음' },
    { value: 0, label: '투자 경험 없음' },
  ];

  // @Watch('selectedRoleCode')
  // onSelectedRoleCodeChanged(newVal: string) {
  //   this.formCData.selectedRoleCode = newVal;
  //   this.formCData.coDept = this.formCData.selectedRoleCode;
  // }

  @Watch('agreeStateInvest')
  onAgreeStateInvestChanged(newVal: number) {
    this.formCData.agreeStateInvest = newVal;
  }

  @Watch('agreeStateBiz')
  onAgreeStateBizChanged(newVal: number) {
    this.formCData.agreeStateBiz = newVal;
  }

  private handleClickSave() {
    const bizPart1 = (this.coBizPart1A && this.coBizPart1B) ? `${this.coBizPart1A}#${this.coBizPart1B}` : '';
    const bizPart2 = (this.coBizPart2A && this.coBizPart2B) ? `${this.coBizPart2A}#${this.coBizPart2B}` : '';
    const bizPart3 = (this.coBizPart3A && this.coBizPart3B) ? `${this.coBizPart3A}#${this.coBizPart3B}` : '';

    const validBizParts = [bizPart1, bizPart2, bizPart3].filter((part) => part.length > 0);

    this.formCData.coBizPart = validBizParts.join('|');

    this.$validator.validate().then((valid: boolean) => {
      // 유효한 UID만 필터링 (비어있는 값 제거)
      const validFiles = this.prImgFiles.filter((file) => file && file.uid);

      if (validFiles.length > 0) {
        // 2. 현재 배열의 순서(index)를 그대로 'ord' 값으로 매핑
        this.formCData.files = validFiles.map((file, index) => ({
          fileUid: file.uid,
          ord: String(index),
        }));
      } else {
        this.formCData.files = [];
      }

      console.log('저장될 파일 데이터(순서 포함):', this.formCData.files);

      // 영상 데이터 → DB 저장용 DTO 변환
      this.formCData.youtubeLink = this.formCData.youtubeList?.join('\n');
      // 구성원 데이터 → DB 저장용 DTO 변환
      const otherTexts = (this.formCData.texts || []).filter((t) => t.part !== 'coMember');
      const memberTexts = (this.formCData.coMember || []).map((memberContent, index) => ({
        part: 'coMember',
        content: memberContent,
        ord: String(index),
      }));

      this.formCData.texts = [...otherTexts, ...memberTexts];

      this.formCData.coDept = this.selectedRoleCode;
      if (valid) {
        if (this.isUpdate) {
          const uid = UserModule.GET_USER_UID;
          updateCompany(this.formCData, uid)
            .then((res) => {
              alert('기업 정보 수정에 성공했습니다.');
              this.$router.go(0);
            })
            .catch((err) => {
              console.error('업데이트 실패 - 에러:', err);
              if (err.response && err.response.data) {
                alert(`수정 실패: ${err.response.data.message || JSON.stringify(err.response.data)}`);
              } else {
                alert('기업 정보 수정에 실패했습니다.');
              }
            });
        }
      } else {
        const inputName = this.$validator.errors.items[0].field;
        document.getElementsByName(inputName)[0].focus();
      }
    });
  }

  private handleClickPostCode() {
    this.$modal.show('postcode');
  }

  private handleComplete(result: any) {
    this.formCData.coAddr = result.address;
    this.formCData.coPostcode = result.zonecode;
    this.$modal.hide('postcode');
  }

  private handleChangeFile(e: any, type: string, idx?: number) {
    const file = e.target.files[0];

    if (!file) return;

    // 용량 제한
    if (file.size > 1024 * 1024 * 50) {
      alert('최대 50MB 까지 업로드 가능합니다.');
      return;
    }

    // 공통 이미지 체크
    const isImage = file.type.startsWith('image');

    if (type === 'logo') {
      if (!isImage) {
        alert('이미지 형식만 업로드 가능합니다.');
        (this.$refs.logoFile as HTMLInputElement).value = '';
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      uploadFile('client/company', formData).then((res) => {
        this.logoFile = res.data;
        this.formCData.logoFileUid = res.data.uid;
      });
    }

    if (type === 'bizCerti') {
      if (!isImage) {
        alert('이미지 형식만 업로드 가능합니다.');
        (this.$refs.bizCertiFile as HTMLInputElement).value = '';
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      uploadFile('client/company', formData).then((res) => {
        this.bizCertiFile = res.data;
        this.formCData.bizCertiFileUid = res.data.uid;
      });
    }

    if (type === 'ir') {
      if (!file.name.endsWith('pdf')) {
        alert('pdf 형식만 업로드 가능합니다.');
        (this.$refs.irFile as HTMLInputElement).value = '';
        return;
      }
      const formData = new FormData();
      formData.append('file', e.target.files[0]);
      uploadFilePdf('client/company', formData).then((res: any) => {
        const [pdfFile, thumbnailFile] = res.data;

        this.irFile = pdfFile; // PDF 파일
        this.formCData.irFileUid = pdfFile.uid;

        if (thumbnailFile) {
          this.thumbnailFile = thumbnailFile;
          this.formCData.thumbnailFileUid = thumbnailFile.uid;
        }
      });
    }
  }

  private handleClickRemoveFile(type: string) {
    if (type === 'logo') {
      this.logoFile = null;
      this.formCData.logoFileUid = '';
    }

    if (type === 'bizCerti') {
      this.bizCertiFile = null;
      this.formCData.bizCertiFileUid = '';
    }

    if (type === 'ir') {
      this.irFile = null;
      this.formCData.irFileUid = '';
    }
  }

  // 구성원 S
  private handleClickAddMember() {
    if (!this.formCData.coMember) this.formCData.coMember = [];
    this.formCData.coMember.push(this.defaultMemberPlaceholder);
  }

  private handleClickRemoveMember(index: number) {
    if (!this.formCData.coMember) return;
    this.formCData.coMember.splice(index, 1);
  }

  private addTextItem() {
    if (!this.formCData.texts) {
      this.formCData.texts = [];
    }
    this.formCData.texts.push({
      part: '추가항목',
      content: '',
      ord: String(this.formCData.texts.length + 1),
    });
  }

  private removeTextItem(index: number) {
    if (this.formCData.texts && this.formCData.texts.length > index) {
      this.formCData.texts.splice(index, 1);
    }
  }

  private resetCoBizPart() {
    this.coBizPart1B = null;
  }

  private resetCoBizPart2() {
    this.coBizPart2B = null;
  }

  private resetCoBizPart3() {
    this.coBizPart3B = null;
  }

  private setBizParts(bizPartString: string | undefined) {
    if (!bizPartString) {
      return;
    }

    const parts = bizPartString.split('|').map((p) => p.trim()).filter((p) => p.includes('#'));

    if (parts[0]) {
      const [partA, partB] = parts[0].split('#');

      if (partA && partB) {
        this.coBizPart1A = partA;
        this.$nextTick(() => {
          this.coBizPart1B = partB;
        });
      }
    }

    if (parts[1]) {
      const [partA, partB] = parts[1].split('#');
      if (partA && partB) {
        this.coBizPart2A = partA;
        this.$nextTick(() => {
          this.coBizPart2B = partB;
        });
      }
    }

    if (parts[2]) {
      const [partA, partB] = parts[2].split('#');
      if (partA && partB) {
        this.coBizPart3A = partA;
        this.$nextTick(() => {
          this.coBizPart3B = partB;
        });
      }
    }
  }

  get cbpbes() {
    const selectedCbpa = this.cbpaes.find((cbpa) => cbpa.label === this.coBizPart1A);
    return selectedCbpa ? selectedCbpa.children : [];
  }

  get cbpbes2() {
    const selectedCbpa = this.cbpaes.find((cbpa) => cbpa.label === this.coBizPart2A);
    return selectedCbpa ? selectedCbpa.children : [];
  }

  get cbpbes3() {
    const selectedCbpa = this.cbpaes.find((cbpa) => cbpa.label === this.coBizPart3A);
    return selectedCbpa ? selectedCbpa.children : [];
  }
}
